import { ArrowDownIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Icon } from '@chakra-ui/react';
import { useHandleExcelExport } from 'pages/ClusterManagement/hooks/useHandleExport';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';
import { useCallback, useState } from 'react';
import icons from 'shared/icons';
import { tableToolbarStyle, iconTableStyle } from 'shared/styles';
import { TProductClusterViewer } from './ProductClusterContainer';

const ProductClusterToolbar = ({ table, actionModalProps, setActionModalType }: TProductClusterViewer) => {
    const handleExcelExport = useHandleExcelExport();

    const [isLoading, setIsLoading] = useState(false);

    const { setGlobalFilter } = table;
    const PlusIcon = icons.plus;

    const handleAddModal = useCallback(() => {
        setActionModalType('add');
        actionModalProps.onOpen();
    }, []);

    const handleExport = async () => {
        setIsLoading(true);
        await handleExcelExport('product-cluster');
        setIsLoading(false);
    };

    return (
        <Flex {...tableToolbarStyle}>
            <GlobalFilter globalFilter={table.getState().globalFilter} setGlobalFilter={setGlobalFilter} />
            <IconButton
                {...iconTableStyle}
                onClick={handleAddModal}
                aria-label="add shop cluster"
                size="sm"
                icon={<Icon as={PlusIcon} />}
            />
            <IconButton
                {...iconTableStyle}
                isLoading={isLoading}
                onClick={handleExport}
                aria-label="download product clusters"
                size="sm"
                icon={<Icon as={ArrowDownIcon} />}
            />
        </Flex>
    );
};

export default ProductClusterToolbar;
